import React from "react";
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import GoogleAds from '@components/advertising/googleAds';
import Layout from '@components/layout';
import Subheader from '@components/subheader';
import P from '@components/paragraph';

const l10nPages = {
  ru: '/ru/kishinev/ulica/teilor',
  ro: '/ro/chisinau/strada/teilor',
  en: '/en/kishinev/street/teilor'
};

export default function Page() {
  return (
    <Layout
      title="str. Teilor, or. Chișinău"
      l10nPages={l10nPages}
      description="str. Teilor, or. Chișinău. Oficii poștale. Denumirile vechi."
    >
      <Container>
        <h1>str. Teilor, or. Chișinău</h1>
        
        <h2>Denumirea veche a străzii</h2>
        <List>
          <ListItem disableGutters>Пловдива ул. (de la 1940 până la 1989)</ListItem>
        </List>
        <GoogleAds />
        <h2>Oficii poștale pentru str. Teilor</h2>
        <P>str. Teilor este deservită
 de o singură sucursală poștală: MD-2043.</P>
        
        <h3>MD-2043</h3>
        <Subheader>str. Teilor, 6</Subheader>
        <Subheader>În zilele lucrătoare de la 08:00 până la 18:00</Subheader>
        

        <List>
          <ListItem disableGutters>str. Teilor: toate</ListItem>
        </List>

      </Container>
    </Layout>
  )
}